import AxiosInstance from "../Utils/axios/axiosConfig";

export const getAlgorithmConfiguration = async () => {
  const response = await AxiosInstance.get("/algorithm-configuration/");
  if (!response?.data?.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const updateAlgorithmConfiguration = async (body) => {
  const response = await AxiosInstance.put("/algorithm-configuration/", body);
  if (!response?.data?.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};
